import { Column } from "components/Table/Simple";
import { formatDateTime } from "components/Table/Simple/presets";
import numeral from "numeral";

export const columns: Column[] = [
    {
        label: "ID",
        field: "id",
    },
    {
        label: "의원명",
        field: "clinic",
        render: (value, field, row) => row?.clinic?.name,
    },
    {
        label: "제목",
        field: "title",
        creatable: true,
    },
    {
        label: "내용",
        field: "content",
        creatable: true,
    },
    {
        label: "시술명",
        field: "treatments",
        render: (value, field, row) => row?.treatments?.map((t) => t.name).join(", "),
    },
    {
        label: "대표이미지",
        field: "mainImage",
        visible: false,
    },
    {
        label: "카드이미지",
        field: "cardImage",
        visible: false,
    },
    {
        label: "상세이미지",
        field: "detailImages",
        visible: false,
    },
    {
        label: "리뷰",
        field: "reviews",
        visible: false,
    },
    {
        field: "created_at",
        label: "생성일",
        render: formatDateTime
    },
    {
        field: "updated_at",
        label: "수정일",
        render: formatDateTime
    },
    {
        field: "clinic_id",
        visible: false,
    },
    {
        field: "averageRating",
        label: "평점",
        render: (value)=> numeral(value).format("0.00"),
    },
    {
        field: "reviewCount",
        label: "리뷰 수",
    }
];